import { useIsWoopDemoMode } from './useIsWoopDemoMode';
import { useWoopAgent } from './useWoopAgent';

type Result = {
  isInstalled: boolean;
  isLoading: boolean;
  error: unknown;
  refetch(): void;
};

/**
 * Reliably determines that WOOP has been really installed e.g. not in demo mode
 */
export function useWoopInstallationStatus(): Result {
  const isWoopDemoMode = useIsWoopDemoMode();
  const agentStatus = useWoopAgent();

  return {
    isInstalled: agentStatus.isWoopAgentInstalled && !isWoopDemoMode,
    isLoading: agentStatus.isAgentStatusLoading,
    error: agentStatus.error,
    refetch: agentStatus.refetch,
  };
}
